var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { HandleMissingTags, ImportJobSource, ImportJobStatus, TagType, } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import { useMissingTags } from '@data/hooks/missingTags';
import { useTagContext } from '@data/tag/tagContext';
import { useCommitImportJob, useDeleteImportJob, useRevertImportJob, useUpdateImportJob, } from '@data/importJob/importJobActions';
import { useImportJobRows } from '@data/importJob/importJobActions';
import Tags from '@shared/tags/Tags';
import Manager from '@shared/modal/Manager';
import TextArea from '@shared/input/TextArea';
import { Confirmation as ConfirmationModal } from '@shared/modal/Simple';
import * as FarseerIcons from '@shared/icons/icons';
import ImportConfigureModal from './ImportConfigureModal';
import ImportMissingTagsModal from './ImportMissingTagsModal';
import ImportActionsMenu from './ImportActionsMenu';
import { downloadFarseerFile, globalLoadingWrapped } from './util';
export default function ImportJobHeader(_a) {
    var _b;
    var _this = this;
    var _c, _d;
    var importJob = _a.importJob;
    var L = useLanguage().L;
    var navigate = useNavigate();
    var tagData = useTagContext().tagData;
    var importJobRows = (_c = useImportJobRows(importJob.id).data) !== null && _c !== void 0 ? _c : [];
    var missingTags = useMissingTags(importJob.metadata.columnMetas, importJobRows, tagData.tagById);
    var updateImportJob = useUpdateImportJob();
    var commitImportJob = useCommitImportJob();
    var revertImportJob = useRevertImportJob();
    var deleteImportJob = useDeleteImportJob();
    var _e = __read(useState((_d = importJob.description) !== null && _d !== void 0 ? _d : ''), 2), description = _e[0], setDescription = _e[1];
    var importJobEditable = importJob.status === ImportJobStatus.CREATED || importJob.status === ImportJobStatus.REVERTED;
    var missingTagsButtonEnabled = missingTags !== null && Object.keys(missingTags).length > 0;
    var importButtonDisabled = importJob.metadata.handleMissingTags === HandleMissingTags.DISALLOW && missingTagsButtonEnabled;
    var goToPreviousImports = function () {
        navigate('/import/previous');
    };
    var commitImportJobHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, accountTagInfo, _a, _b, importCellInfo, accountTag;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return commitImportJob.mutateAsync(importJob.id); })];
                case 1:
                    result = _d.sent();
                    if (result !== undefined) {
                        accountTagInfo = [];
                        try {
                            for (_a = __values(result.importedCells), _b = _a.next(); !_b.done; _b = _a.next()) {
                                importCellInfo = _b.value;
                                accountTag = tagData.tagById[importCellInfo.accountTagId];
                                if (accountTag !== undefined) {
                                    accountTagInfo.push("".concat(accountTag.name, ": ").concat(importCellInfo.count, " ").concat(L('cells')));
                                }
                                else {
                                    accountTagInfo.push("".concat(L('Unknown variable'), ": ").concat(importCellInfo.count, " ").concat(L('cells')));
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        toast.success("".concat(L('Success'), "! ").concat(L('Imported cells'), ":\n").concat(accountTagInfo.join('\n')));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var revertImportJobHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, revertImportJob.mutateAsync(importJob.id)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var archiveImportJobHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateImportJob.mutateAsync({ id: importJob.id, status: ImportJobStatus.ARCHIVED })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    goToPreviousImports();
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteImportJobHandler = function () {
        Manager.renderModal(React.createElement(ConfirmationModal, { width: 500, title: L('Confirm'), onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, deleteImportJob.mutateAsync(importJob.id)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                        case 1:
                            _a.sent();
                            goToPreviousImports();
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("span", null,
                L('Are you sure you want to delete'),
                " ",
                L('this import job'),
                '?')));
    };
    var replaceImportJob = function () {
        navigate("/import/replace/".concat(importJob.id));
    };
    var saveDescriptionHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateImportJob.mutateAsync({ id: importJob.id, description: description.trim() })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var showConfigureModal = function () {
        Manager.renderModal(React.createElement(ImportConfigureModal, { importJob: importJob }));
    };
    var showMissingTagsModal = function () {
        Manager.renderModal(React.createElement(ImportMissingTagsModal, { importJobId: importJob.id }));
    };
    var addImportJobDimensionTag = function (tagIdToAdd) { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateImportJob.mutateAsync({
                                        id: importJob.id,
                                        metadata: __assign(__assign({}, importJob.metadata), { dimensionTagIds: __spreadArray(__spreadArray([], __read(importJob.metadata.dimensionTagIds), false), [tagIdToAdd], false) }),
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var removeImportJobDimensionTag = function (tagIdToRemove) { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateImportJob.mutateAsync({
                                        id: importJob.id,
                                        metadata: __assign(__assign({}, importJob.metadata), { dimensionTagIds: importJob.metadata.dimensionTagIds.filter(function (tId) { return tId !== tagIdToRemove; }) }),
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var undoJobButton = (React.createElement(FSButton, { "$type": "primary", "$color": "error", title: L('Undo'), onClick: revertImportJobHandler }));
    var importDimensionTags = importJob.metadata.dimensionTagIds
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (tag) { return tag !== undefined; });
    var importDimensionTagsSelector = (React.createElement(Tags, { tags: importDimensionTags, canUpdate: importJobEditable, select: addImportJobDimensionTag, remove: removeImportJobDimensionTag, filterByTypes: [TagType.Dimension], afterButtonLabel: L('Add dimensions to job'), afterButtonLabelType: TagType.Dimension }));
    var activeImportJobButtons = (React.createElement(React.Fragment, null,
        React.createElement(FSButton, { "$type": "tertiary", title: L('Configure'), onClick: showConfigureModal }),
        React.createElement(FSButton, { "$type": "secondary", "$color": "warning", disabled: !missingTagsButtonEnabled, title: L('Create Missing Dimensions'), onClick: showMissingTagsModal }),
        React.createElement(FSButton, { disabled: importButtonDisabled, title: L('Import'), onClick: commitImportJobHandler })));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "import-header" },
            React.createElement(FSButton, { "$type": "tertiary", title: L('Previous imports'), icon: FarseerIcons.ChevronLeft, onClick: goToPreviousImports }),
            importDimensionTagsSelector,
            React.createElement("div", { className: "import-header-box" },
                (_b = {},
                    _b[ImportJobStatus.CREATED] = activeImportJobButtons,
                    _b[ImportJobStatus.COMMITED] = undoJobButton,
                    _b[ImportJobStatus.ARCHIVED] = React.createElement(React.Fragment, null),
                    _b[ImportJobStatus.REVERTED] = activeImportJobButtons,
                    _b)[importJob.status],
                React.createElement(ImportActionsMenu, { items: [
                        // {
                        //     actionName: L('Edit Labels'),
                        //     icon: FarseerIcons.Edit,
                        // },
                        {
                            actionName: L('Archive'),
                            icon: FarseerIcons.Archive,
                            isDisabled: importJob.status === ImportJobStatus.ARCHIVED,
                            action: function () { return archiveImportJobHandler(); },
                        },
                        {
                            actionName: L('Replace'),
                            icon: FarseerIcons.Refresh,
                            isDisabled: importJob.status === ImportJobStatus.ARCHIVED,
                            action: function () { return replaceImportJob(); },
                        },
                        {
                            actionName: L('Download File'),
                            icon: FarseerIcons.Download,
                            isDisabled: importJob.source !== ImportJobSource.FARSEER_FILE ||
                                importJob.farseerFileId === null,
                            action: function () {
                                return importJob.farseerFileId !== null
                                    ? downloadFarseerFile(importJob.farseerFileId, importJob.title)
                                    : {};
                            },
                        },
                        {
                            spacer: true,
                        },
                        {
                            actionName: L('Delete'),
                            icon: FarseerIcons.Delete,
                            destructive: true,
                            action: function () { return deleteImportJobHandler(); },
                        },
                    ] }))),
        React.createElement("div", { className: "import-header-title" }, importJob.title),
        importJob.status === ImportJobStatus.COMMITED && (React.createElement("div", { className: "import-header-description" },
            React.createElement(TextArea, { label: L('Add a description for this import'), name: "description", value: description !== null && description !== void 0 ? description : '', onChange: function (e) { return setDescription(e.target.value); }, bottomMargin: true, css: { width: '100%' } }),
            React.createElement("div", { className: "save-box", style: { visibility: importJob.description !== description ? 'visible' : 'hidden' } },
                React.createElement(FSButton, { "$type": "secondary", title: "Save description", onClick: saveDescriptionHandler }))))));
}
